module.exports = __webpack_public_path__ + "img/solar_upload-outline.dc3da098.svg";